<template>
  <div class="ioc_input_edit_container">
    <el-input type="text"
              v-model="value"
              @input="handleInput($event)"
              :placeholder="placeholder" />
    <div class="action_option">
      <span @click.stop="handleSave">
        <el-tooltip class="item"
                    effect="dark"
                    :content="$t('video.button.confirm')"
                    placement="top">
          <i class="el-icon-check"></i>
        </el-tooltip>
      </span>
      <span @click.stop="handleCancel">
        <el-tooltip class="item"
                    effect="dark"
                    :content="$t('video.button.cancel')"
                    placement="top">
          <i class="el-icon-close"></i>
        </el-tooltip>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ioc-input-edit',
  directives: {
    focus: {
      inserted: function (el) {
        // el.focus()
      }
    }
  },
  model: {
    prop: 'val',
    event: 'handleReturn'
  },
  props: {
    val: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: function () {
        return this.$t('video.placeholder.name');
      }
    }
  },
  data () {
    return {
      value: ''
    }
  },
  watch: {
    val: function (newVal) {
      this.value = newVal
    }
  },
  mounted () {
    this.value = this.val
  },
  methods: {
    handleSave () {
      this.$emit('save')
    },
    handleCancel () {
      this.$emit('cancel')
    },
    handleReturn () {
      this.$emit('handleReturn', this.value)
    },
    handleInput (e) {
      // this.value = e.target.value;
      this.value = e;
      this.handleReturn()
    }
  }
}
</script>

<style lang="scss" scoped>
.ioc_input_edit_container {
  width: 100%;
  display: flex;
  flex-direction: row;

  input[type="text"] {
    flex: 1;
    border: 1px solid #394567;
    border-radius: 2px;
    padding: 0 8px;
    height: 100%;
    width: 100%;
    line-height: 24px;
    margin: 0;

    &:focus {
      border-color: #407aee;
      color: #fff;
    }

    &::-webkit-input-placeholder {
      /* WebKit, Blink, Edge */
      color: #586583 !important;
    }

    &::-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      color: #586583 !important;
    }

    &:-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: #586583 !important;
    }

    &:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #586583 !important;
    }
  }

  .action_option {
    display: flex;
    flex-direction: row;
    align-items: center;

    > span {
      padding: 0 5px;
      cursor: pointer;

      &:first-child {
        margin-left: 10px;
      }

      i {
        font-size: 18px;
      }

      &:last-child {
        padding-right: 0;
      }
    }
  }
}
</style>
